(function ($, Drupal, drupalSettings, once) {

    'use strict';

    /*
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * Globally accessible API
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     */

    Promutuel.hero = {

      /**
       * Change mutual button / checkmark.
       */
      personalizeUI: function (mutualId) {
        if (drupalSettings.current_mutual_internal_id == mutualId) {
          $('.js-mutual-hero-btn').addClass('d-none');
          $('.js-mutual-hero-link').removeClass('d-none');
        }
        else {
          $('.js-mutual-hero-link').addClass('d-none');
          $('.js-mutual-hero-btn').removeClass('d-none');
        }
      }
    };

    /*
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     * Behaviors and event management
     * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
     */

    Drupal.behaviors.promutuel_hero = {
      attach: function attach(context) {

        // Always run personalization at page load, so that at least one of the buttons is displayed.
        Promutuel.hero.personalizeUI(Promutuel.mutuals?.getMyMutualId());

        // Set Mutual button handler.
        $(once('promutuelHero', '.hero .js-set-mutual-on-hero', context)).on('click', function(event) {
          event.preventDefault();
          if (drupalSettings.current_mutual_internal_id)
            Promutuel.mutuals.setMyMutual({ 'id': drupalSettings.current_mutual_internal_id });
        });
      }
    };

  })(jQuery, Drupal, drupalSettings, once);
